import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';
import { UserSequenceEditor } from '@/components/user/UserSequenceEditor';
import { useAuth } from '@/contexts/AuthContext';

const EditSequence = () => {
  const { id } = useParams<{ id: string }>();
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/auth?redirect=/my-sequences" replace />;
  }

  if (!id) {
    return <Navigate to="/my-sequences" replace />;
  }

  return (
    <>
      <Helmet>
        <title>Edit Sequence - LightsHunt</title>
        <meta name="description" content="Edit your light sequence details, pricing, and metadata." />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        <NavBar />
        <main className="pt-20">
          <UserSequenceEditor sequenceId={id} />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default EditSequence;